var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-console, no-var, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp, space-before-function-paren, space-infix-ops */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var BlurInput = require("react-components/blur-input.jsx");
var InfoTip = require("../components/info-tip.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");

var DEFAULT_WIDTH = 400;
var DEFAULT_HEIGHT = 400;

/**
 * This is used for editing a name/value pair.
 */
var PairEditor = React.createClass({
    displayName: "PairEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        name: React.PropTypes.string,
        value: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            name: "",
            value: ""
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        return React.createElement(
            "fieldset",
            { className: "pair-editor" },
            React.createElement(
                "label",
                null,
                "Name:",
                " ",
                React.createElement(BlurInput, {
                    value: this.props.name,
                    onChange: this.change("name")
                })
            ),
            React.createElement(
                "label",
                null,
                " ",
                "Value:",
                " ",
                React.createElement(BlurInput, {
                    value: this.props.value,
                    onChange: this.change("value")
                })
            )
        );
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

/**
 * This is used for editing a set of name/value pairs.
 */
var PairsEditor = React.createClass({
    displayName: "PairsEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        pairs: React.PropTypes.arrayOf(React.PropTypes.shape({
            name: React.PropTypes.string,
            value: React.PropTypes.string
        })).isRequired
    }),

    render: function render() {
        var _this = this;

        var editors = _.map(this.props.pairs, function (pair, i) {
            return React.createElement(PairEditor, {
                key: i,
                name: pair.name,
                value: pair.value,
                onChange: _this.handlePairChange.bind(_this, i)
            });
        });
        return React.createElement(
            "div",
            null,
            editors
        );
    },

    change: function change() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return Changeable.change.apply(this, args);
    },


    handlePairChange: function handlePairChange(pairIndex, pair) {
        // If they're both non empty, add a new one
        var pairs = this.props.pairs.slice();
        pairs[pairIndex] = pair;

        var lastPair = pairs[pairs.length - 1];
        if (lastPair.name && lastPair.value) {
            pairs.push({ name: "", value: "" });
        }
        this.change("pairs", pairs);
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

var KA_PROGRAM_URL = /khanacademy\.org\/computer-programming\/[^\/]+\/(\d+)/;

/**
 * Given a program URL from the site, extract its program ID.
 * If the input does not match the known URL patterns, it is assumed to be
 * a program ID.
 */
function isolateProgramID(programUrl) {
    var match = KA_PROGRAM_URL.exec(programUrl);
    if (match) {
        programUrl = match[1];
    }

    return programUrl;
}

/**
 * This is the main editor for this widget, to specify all the options.
 */
var CSProgramEditor = React.createClass({
    displayName: "CSProgramEditor",

    propTypes: _extends({}, Changeable.propTypes),

    getDefaultProps: function getDefaultProps() {
        return {
            programID: "",
            settings: [{ name: "", value: "" }],
            showEditor: false,
            showButtons: false,
            width: DEFAULT_WIDTH,
            height: DEFAULT_HEIGHT
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            null,
            React.createElement(
                "label",
                null,
                "Url or Program ID:",
                " ",
                React.createElement(BlurInput, {
                    name: "programID",
                    value: this.props.programID,
                    onChange: this._handleProgramIDChange
                })
            ),
            React.createElement("br", null),
            React.createElement(PropCheckBox, {
                label: "Show Editor",
                showEditor: this.props.showEditor,
                onChange: this.props.onChange
            }),
            React.createElement(
                InfoTip,
                null,
                "If you show the editor, you should use the \"full-width\" alignment to make room for the width of the editor."
            ),
            React.createElement("br", null),
            React.createElement(PropCheckBox, {
                label: "Show Buttons",
                showButtons: this.props.showButtons,
                onChange: this.props.onChange
            }),
            React.createElement("br", null),
            React.createElement(
                "label",
                null,
                "Settings:",
                React.createElement(PairsEditor, {
                    name: "settings",
                    pairs: this.props.settings,
                    onChange: this._handleSettingsChange
                }),
                React.createElement(
                    InfoTip,
                    null,
                    "Settings that you add here are available to the program as an object returned by ",
                    React.createElement(
                        "code",
                        null,
                        "Program.settings()"
                    )
                )
            )
        );
    },

    change: function change() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
        }

        return Changeable.change.apply(this, args);
    },


    _handleSettingsChange: function _handleSettingsChange(settings) {
        this.change({ settings: settings.pairs });
    },

    _handleProgramIDChange: function _handleProgramIDChange(programID) {
        var _this2 = this;

        programID = isolateProgramID(programID);

        $.getJSON("https://www.khanacademy.org/api/internal/scratchpads/" + programID).done(function (programInfo) {
            _this2.change({
                width: programInfo.width,
                height: programInfo.height,
                programID: programID
            });
        }).fail(function (jqxhr, textStatus, error) {
            console.error("Error retrieving scratchpad info for " + "program ID ", programID);
            console.error(textStatus + ", " + error);
            _this2.change({
                width: DEFAULT_WIDTH,
                height: DEFAULT_HEIGHT,
                programID: programID
            });
        });
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = CSProgramEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/cs-program-editor.jsx
 ** module id = 97
 ** module chunks = 0 1
 **/